module.exports = __webpack_public_path__ + "static/media/image3.02a7df9e.png";